import * as React from "react";
import type { SVGProps } from "react";
const SvgServingFoodWithPlusCloche = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.01 12c.55 0 1 .45 1 1v.13l.94-.63c.49-.33 1.07-.5 1.66-.5H12c1.1 0 2 .9 2 2h3.16c.86 0 1.61.53 1.89 1.34.285.825-.004 1.827-.76 2.3l-3.3 1.94c-.46.27-.99.41-1.52.41H8.34c-.32 0-.64-.05-.95-.15l-1.45-.48c-.15.37-.51.64-.93.64h-3c-.55 0-1-.45-1-1v-6c0-.55.45-1 1-1h3ZM3 18h1v-4H3v4Zm5.6-4c-.2 0-.39.06-.56.17l-2.05 1.37v1.74l2.01.67c.11.03.21.05.32.05h5.13c.18 0 .36-.05.51-.14h-.01L17.12 16h-5.13c-.55 0-1-.45-1-1s.45-1 1-1H8.6ZM10 0c.55 0 1 .45 1 1v1.07c3.61.45 6.48 3.32 6.93 6.93H19c.55 0 1 .45 1 1s-.45 1-1 1H1c-.55 0-1-.45-1-1s.45-1 1-1h1.07A8.002 8.002 0 0 1 9 2.07V1c0-.55.45-1 1-1Zm-.5 4a.25.25 0 0 0-.25.25V5.5a.25.25 0 0 1-.25.25H7.75A.25.25 0 0 0 7.5 6v1c0 .138.112.25.25.25H9a.25.25 0 0 1 .25.25v1.25c0 .138.112.25.25.25h1a.25.25 0 0 0 .25-.25V7.5a.25.25 0 0 1 .25-.25h1.25A.25.25 0 0 0 12.5 7V6a.25.25 0 0 0-.25-.25H11a.25.25 0 0 1-.25-.25V4.25A.25.25 0 0 0 10.5 4h-1Z"
    />
  </svg>
);
export default SvgServingFoodWithPlusCloche;
